export const CpdCategoryName = {
  responsibleManager: 'Responsible Managers CPD',
  genecalCpd: 'General CPD'
}

export const defaultUnselectedCpdCategorys = [
  CpdCategoryName.responsibleManager
]

export const CpdCategoryStatus = {
  archived: 'Archived',
  active: 'Active'
}


// WEBPACK FOOTER //
// ./src/constants/area-of-advice.js